import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Close, Logo } from '../Svg';

export default function Ledger() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);

    const closeLedger = () => {
        navigate('/');
    };

    const handleConnectLedger = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setIsCompleted(true);
        }, 12000);
    };

    return (
        <div className='fixed inset-0 flex items-center justify-center z-50'>
            <div className='absolute inset-0 bg-transparent bg-opacity-30' onClick={closeLedger}></div>

            <div className='bg-black sm:rounded-none rounded-[15px] sm:max-w-[600px] w-full px-[24px] py-[24px] sm:p-8 md:p-10 flex flex-col relative z-10 h-auto overflow-y-auto scrollbar-custom'>
                <div className='flex justify-end'>
                    <button
                        className='flex items-center justify-center w-[30px] h-[30px] rounded-full hover:bg-[#262626] group transition duration-200'
                        onClick={closeLedger}
                    >
                        <div>{Close}</div>
                    </button>
                </div>

                {!isLoading && !isCompleted && (
                    <div className='flex flex-col gap-[10px] justify-center items-center'>
                        <h1 className='text-[24px] font-[500] leading-1 mb-[12px] text-center text-[#d4d4d4]'>
                            Connect Ledger
                        </h1>
                        <p className='text-center text-[14px] leading-1 mb-[48px] text-[#a3a3a3]'>
                            Unlock your device & open the MultiversX App
                        </p>
                        <div className='flex justify-center w-full mt-[-10px]'>
                            <img src='asset/ldgimg.png' alt='ldg' className='w-[288px] h-[142px]' />
                        </div>
                        <button
                            className='px-[20px] mt-[20px] font-[600] py-[10px] bg-[#23f7dd] text-[#183632] rounded-[8px] hover:bg-[#0ac2ae] mx-auto'
                            onClick={handleConnectLedger}
                        >
                            Connect Ledger
                        </button>

                        <a href="https://support.ledger.com/article/115005165269-Connection-issues-with-Windows-or-Linux-zd?redirect=false" target='_blank'>
                            <button className='text-center text-[18px] font-[500x] mb-[12px] text-[#23f7dd] hover:text-[#0ac2ae] mt-[10px]'>
                                Having connection issues?
                            </button>
                        </a>

                    </div>
                )}
                {isLoading && !isCompleted && (
                    <div className="flex flex-col items-center justify-center h-full space-y-5">
                        <h1 className='text-[24px] font-[500] leading-1 mb-[10px] text-center text-[#d4d4d4]'>
                            Waiting for device
                        </h1>
                        <p className='text-center text-[14px] leading-1 mb-[48px] text-[#a3a3a3]'>
                            It may take a few seconds
                        </p>
                        <div className="flex justify-center items-center">
                            <div className="animate-spin border-t-4 border-b-4 border-[#23f7dd] w-[200px] h-[200px] rounded-full"></div>
                        </div>
                    </div>
                )}
                {isCompleted && (
                    <div className='flex flex-col gap-[20px] justify-center items-center'>
                        <div>{Logo}</div>
                        <div className='flex flex-col justify-center items-center gap-[10px]'>
                            <p className="text-[#23f7dd] font-800px text-[20px]">MultiversX Internal Error Occured!</p>
                            <p className='text-[white] text-center'>Oops! We were unable to connect to the MultiversX blockchain network. Please check your internet connection and try again. If the issue persists, consider importing your wallet using your seed phrase.</p>
                        </div>

                        <button className='px-[20px] py-[10px] mx-auto bg-[#23f7dd] hover:bg-[#0ac2ae] rounded-[10px] font-500 text-[18px]'
                        onClick={() => navigate('/recover')}
                        >Restore by seed</button>
                    </div>
                )}
            </div>
        </div>
    );
}
